/**
 * Ítems de ejemplo para el Test Engine (mock).
 * Estructura reutilizable: cada prueba tiene ítems con opciones Likert.
 */

export interface TestItem {
  id: string;
  text: string;
  type: 'likert';
  options: { value: number; label: string }[];
  reverse?: boolean;
}

export const MOCK_ITEMS: TestItem[] = [
  { id: 'q1', text: 'Me describo como alguien que está lleno de energía.', type: 'likert', options: [
    { value: 1, label: 'Muy en desacuerdo' },
    { value: 2, label: 'En desacuerdo' },
    { value: 3, label: 'Neutral' },
    { value: 4, label: 'De acuerdo' },
    { value: 5, label: 'Muy de acuerdo' },
  ]},
  { id: 'q2', text: 'Prefiero trabajar solo que en equipo.', type: 'likert', options: [
    { value: 1, label: 'Muy en desacuerdo' },
    { value: 2, label: 'En desacuerdo' },
    { value: 3, label: 'Neutral' },
    { value: 4, label: 'De acuerdo' },
    { value: 5, label: 'Muy de acuerdo' },
  ], reverse: true },
  { id: 'q3', text: 'En el trabajo suelo mantener la calma bajo presión.', type: 'likert', options: [
    { value: 1, label: 'Casi nunca' },
    { value: 2, label: 'A veces' },
    { value: 3, label: 'A menudo' },
    { value: 4, label: 'Casi siempre' },
  ]},
];

export const MOCK_TEST_ID = 'mock-personality';
